import React from 'react';
import { useTranslation } from 'react-i18next';
import { useCommonSelector } from '@wajeez-web/stores/common';
import { InputLabel } from '@wajeez-web/components/ui';
import { MappedFormType, RequiredComponentFormType } from '../Types';
import {
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';
import Select from 'react-select';

export interface FormRequiredComponentInputProps<
  TFormFields extends FieldValues
> extends UseControllerProps<TFormFields> {
  fieldType: RequiredComponentFormType;
  disabled?: boolean;
}

const FormRequiredComponentInput = <TFormFields extends FieldValues>({
  fieldType,
  disabled,
  ...props
}: FormRequiredComponentInputProps<TFormFields>) => {
  const { field, fieldState } = useController({
    ...props,
    rules: {
      required: fieldType.required ? 'Required' : undefined,
      ...props.rules,
    },
  });

  const { dir } = useCommonSelector((state) => state.common.settings);

  const { t } = useTranslation();

  const isError = fieldState.error && fieldState.isTouched;

  // TODO: Redo This
  return (
    <>
      {fieldType.label && (
        <InputLabel
          text={
            t(
              `inputs.labels.${fieldType.label}`,
              fieldType.label.toString() || ''
            ) as string
          }
          name={field.name}
          required={fieldType.required}
        />
      )}
      <Select
        isMulti={true}
        placeholder={fieldType.placeHolder}
        isDisabled={disabled}
        className={isError ? 'border-red-500' : ''}
        {...field}
        // name={name as string}
        //   value={
        //     contentEntityTypeswithfields?.length &&
        //     values[name] &&
        //     values[name]?.length > 0 &&
        //     values[name]
        //       ?.map((element: any) =>
        //         contentEntityTypeswithfields
        //           ?.find((item) =>
        //             item.fields.find((ele) => ele.id === element)
        //           )
        //           ?.fields.find((item) => item.id === element)
        //       )
        //       ?.map((ele: any) => ({ label: ele.label, value: ele.id }))
        //   }
        //   options={contentEntityTypeswithfields?.map((item: any) => ({
        //     label: item.name,
        //     options: item.fields.map((ele: any) => ({
        //       label: ele.label,
        //       value: ele.id,
        //     })),
        //   }))}
      />
    </>
  );
};

export default FormRequiredComponentInput;
